module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_c('span', [_vm._v("INTRODUCTION")]), _c('br'), _vm._v("\n    A TESTAMENT OF LISTENING")])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_c('span', [_vm._v("1 • THE EARLIEST VOICES")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("Our beginnings shape us. We start with what we’re given. For me that was my birth mother, Olive.")])])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "#/chap2"
    }
  }, [_c('span', [_vm._v("2 • DISCERNING ONE VOICE FROM ANOTHER")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("As I grew I needed to learn to think my own thoughts, to trust\n        my own heart, and to measure what I heard against\n        what I ")])])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/chap2"
    }
  }, [_c('i', [_vm._v("sensed to be God’s direction.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("3 • CHOOSING TO BECOME A LISTENER")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("In childhood, I had to listen to Mother’s voice. Then came a\n    time when I chose to be a listener for God’s voice for myself.")])])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("4 • CALLED TO LEAD, LED TO PREACH")])]), _c('br'), _c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The voice of an encourager and an arm around the shoulder that have stayed with me ever since.")])])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("5 • CROSSING NEW THRESHOLDS")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("At Wheaton, the voices of the mind, of love, of calling\n    drew into me and through me and out of me threads\n    that have stitched my life.")])])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("6 • THE MENTOR AND THE MOCKINGBIRD")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("My relationship with Billy Graham allowed me to\n    learn from a master communicator yet have\n    space to find my own voice.")])])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("7 • DISCERNING A SHIFT")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("After an earthquake I began to sense some disturbing voices. I woke up to realities beyond my own comfort zone.")])])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("8 • VOICES IN A DARK NIGHT")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("God died one night in the winter of 1967. It was my assurance that faded, not God, but still my sense of loss was very acute. Shivering alone by a cold seaside, I realized that the Incomparable Voice was trying to get my attention.")])])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("9 • PIECES IN THE IDENTITY PUZZLE")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("Voices from the past and in the blood also call to us, quietly\n    but deeply. At sixty I met my mother for the first time. In uncovering these roots—and tracing them from Ontario to Arkansas and back—I heard the\n    voice of love in another accent.")])])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("10 • LOSING A SON, RESTORING A SOUL")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("Friends said I was markedly different after our son died. How did a broken heart change me?")])])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("11 • A MANTLE FALLING, A SEED GROWING")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("Deep in the pain of loss, a seed was growing. It was the desire to have other “sons” and “daughters”\n    become part of our lives.")])])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("12 • THE START OF A SECOND JOURNEY")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("My second journey involved letting go of an organization\n    and a profile. A calling of doing and becoming.")])])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("13 • A VOICE AFTER THE HURRICANE")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("Hurricane Hugo interrupted our planning session. It opened me to listen deeply to “the voice after the storm.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("14 • WHEN WE LOSE OUR WAY")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("When we lose our way we can either panic and freeze or stand still and listen for a Voice (or voices) that can tell us where we need to go.")])])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("15 • THE VOICE OF BEAUTY")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("Life changed again when the voice of beauty spoke in a way that blossomed into a new sense of vocation—artist of the soul—and a new way of seeing.")])])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("16 • A VOICE AMONG THE VOICES")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("God’s voice has so often come to me like the clouds, not in a single instant but in an accumulation of voices and happenings.")])])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("17 • SUMMONED TO ATTENTIVENESS")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("Insights for a lifetime of listening.")])])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("18 • THE SOUND OF THAT VOICE")]), _c('br'), _vm._v(" "), _c('i', [_vm._v("What will it sound like when we hear God speak to us?")])])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PRAISE FOR "), _c('i', [_vm._v("A LIFE OF LISTENING")])])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHOR")])]), _vm._v(" "), _c('div', {
    staticClass: "mev1"
  }), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MORE TITLES FROM INTERVARSITY PRESS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 66
// module chunks = 0